<template>
  <span class="status" :class="cls" :title="cls">
    {{ icon }}
    <slot name="default"></slot>
    <slot v-if="props.online" name="online"></slot>
    <slot v-else name="offline"></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export type OnlineStatus = boolean | null | undefined

const props = withDefaults(
  defineProps<{
    online: OnlineStatus
  }>(),
  {
    online: undefined,
  },
)

export type AllowedStatus = 'true' | 'false' | 'null' | 'undefined'
export type PerStatusMap<T> = {
  [key in AllowedStatus]: T
}

const CLASSES: PerStatusMap<string> = {
  true: 'online',
  false: 'offline',
  null: 'hidden',
  undefined: 'unknown',
}

const ICONS: PerStatusMap<string> = {
  true: '●',
  false: '○',
  null: '◌',
  undefined: ' ',
}

function s(value: OnlineStatus): AllowedStatus {
  if (value === undefined) {
    return 'undefined'
  }
  if (value === null) {
    return 'null'
  }
  return value ? 'true' : 'false'
}

function getClass() {
  return CLASSES[s(props.online)]
}

function getIcon() {
  return ICONS[s(props.online)]
}

const cls = computed(() => getClass())
const icon = computed(() => getIcon())
</script>

<style scoped lang="scss">
.status {
  &.online {
    color: #2ecc71;
  }
  &.offline {
    color: #95a5a6;
  }
  &.unknown {
    color: #aaa;
  }
}
</style>
